import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useWorkspace } from "@/context/WorkspaceContext";

export default function PaymentSuccess() {
  const { api } = useWorkspace();
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState({ phase: "checking" });
  useEffect(() => {
    let tries = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.status === "completed") return setState({ phase: "done", kind: data.kind });
        if (["expired", "failed"].includes(data.status)) return setState({ phase: "failed" });
      } catch { /* keep polling */ }
      if (!stop && ++tries < 15) setTimeout(poll, 2000); else if (!stop) setState({ phase: "slow" });
    };
    if (sid) poll(); else setState({ phase: "failed" });
    return () => { stop = true; };
  }, [api, sid]);
  const { phase, kind } = state;
  return (
    <div className="mx-auto max-w-md py-16 text-center" data-testid="payment-result">
      {phase === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" /><p className="mt-4" data-testid="payment-checking">Confirming your payment with Stripe…</p></>}
      {phase === "done" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" /><p className="mt-4 font-display text-2xl" data-testid="payment-done">{kind === "topup" ? "Credit added" : "Subscription started"}</p><p className="mt-2 text-sm text-muted-foreground">{kind === "topup" ? "Your new credit is ready to use." : "Thanks — your research credit refreshes every month."}</p></>}
      {phase === "failed" && <><XCircle className="mx-auto h-12 w-12 text-destructive" /><p className="mt-4 font-display text-2xl" data-testid="payment-failed">Payment not completed</p><p className="mt-2 text-sm text-muted-foreground">No money was taken. You can try again from Billing.</p></>}
      {phase === "slow" && <p className="text-sm" data-testid="payment-slow">Stripe is taking longer than usual to confirm. Your Billing page will update as soon as it does.</p>}
      <Button asChild className="mt-8" data-testid="payment-back"><Link to="/billing">Back to Billing</Link></Button>
    </div>
  );
}
